import * as _ from 'underscore'
import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpLocation, OpLocationEquipment, OpFile } from "../models/core"
import { ColumnInfo } from "../models/custom"
import { OpEquipmentQuantity } from "../models/custom/op-equipment-quantity"
import { OpExportPluginParam } from "../models/util"
import { DataProviderListResult } from './data-provider.interfaces'

export class DataProviderDepository {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion

    // #region Public Methods

    public getDepository = (id: number): JQueryPromise<OpLocation> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetDepository', { IdLocation: id }, 'OpxGetDepositoryResult')
            .then((response: any) => {
                if (response != null) {
                    const result: OpLocation = new OpLocation(response)

                    return OpLocation
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((depositories: OpLocation[]) => _.first(depositories))
                }

                return null
            })
    }

    public getDepositoryFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpLocation>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdLocation, 'OpxDepositoryFilter', 'OpxDepositoryFilterResult')
    }

    public getDepositoryContent = (idDepository: number) => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetDepositoryContent', { IdDepository: idDepository, OnlyCurrent: true }, 'OpxGetDepositoryContentResult')
            .then((data: any[]) => data.map(dataItem => new OpLocationEquipment(dataItem)))
    }

    public getDepositoryContentFilter = (idDepository: number, columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<DataProviderListResult<OpLocationEquipment>> => {
        return this.dataProvider.sendFilterRequestWithSession<OpLocationEquipment>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdLocationEquipment, 'OpxDepositoryContentFilter', 'OpxDepositoryContentFilterResult', { IdDepository: idDepository, OnlyCurrent: true })
    }

    public depositoryExport = (referenceType: Enums.ReferenceType, columns: ColumnInfo[], customWhereClause: string, dllName: string, params: OpExportPluginParam[]) => {
        const requestArgs: any = {
            ReferenceType: referenceType,
            Columns: columns,
            CustomWhereClause: customWhereClause,
            DllName: dllName,
            exportParams: params != null ? params.map((param: OpExportPluginParam) => param.toJSON()) : null
        }

        return this.dataProvider
            .sendRequestWithSession('OpxDepositoryExport', requestArgs, 'OpxDepositoryExportResult')
            .then((data: any) => {
                if (data != null) {
                    return new OpFile(data)
                }

                return null
            })
    }

    public useAgainDepositoryElement = (equipment: OpLocationEquipment[]): JQueryPromise<OpLocationEquipment[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxUseAgainDepositoryElement', { ElementsToUseAgain: equipment.map((equipmentItem: OpLocationEquipment) => equipmentItem.toJSON()) }, 'OpxUseAgainDepositoryElementResult')
            .then((data: any) => {
                return data.map((opObj: any) => new OpLocationEquipment(opObj))
            })
    }

    public saveDepository = (depository: OpLocation): JQueryPromise<OpLocation> => {
        depository.dataList.setValue(Enums.LocationType.DepositoryLocation, Enums.DataType.HELPER_ID_LOCATION_TYPE)

        return this.dataProvider.Location.saveLocation(depository)
    }

    public getQuantityToFillDepositoryMinimum = (idDepository: number[], idOrder: number[]): JQueryPromise<OpEquipmentQuantity[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetQuantityToFillDepositoryMinimum', { idDepository: idDepository, idOrder: idOrder }, 'OpxGetQuantityToFillDepositoryMinimumResult')
            .then((response: any) => {
                return response.map((opObj: any) => new OpEquipmentQuantity(opObj))
            })
    }

    // #endregion
}